<template>
  <div class="selectionform">
    <div class="panelheader border-blue">
      <div class="booker-title">Book a field</div>
    </div>
        
    <div class="body">
      
      <bookingselect
        title="Booking Type"
        placeholder="Please select your booking type"
        :options="types"
        :selected="bookingData.type.name"
        @selected="onTypeSelected">
      </bookingselect>

      <bookingselect
        v-show="showSites"
        title="Available Sites"
        placeholder="Please select a site"
        :options="sites"
        :selected="bookingData.site.name"
        @selected="onSiteSelected">
      </bookingselect>

      <bookingselect
        v-show="showScenes"
        title="Scene"
        placeholder="Please select the required scene"
        :options="scenes"
        :selected="bookingData.scene.name"
        @selected="onSceneSelected">
      </bookingselect>


      <bookingselect
        title="Duration"
        placeholder="Please select the required duration"
        :options="durations"
        :selected="bookingData.duration.name"
        @selected="onDurationSelected">
      </bookingselect>

      <div class="datetime-wrapper" v-show="bookingData.site">
        <el-col :xs="24" :sm="12">
          
          <flatpickr 
            :options="fpOptions"
            v-model="bookingData.date">
          </flatpickr>

        </el-col>

        <el-col :xs="24" :sm="12">

          <div class="dateTag">{{ prettyDateTag }}</div>

          <div class="timepicker">

            <el-tabs 
              type="card" 
              v-loading="showDateLoading"
              v-model="activeTab">

              <el-tab-pane label="Morning" name="Morning">
                <div v-if="!morningTimes">
                  No Available Times
                </div>
                <div v-else>
                  <div v-for="t in morningTimes()" :key="t.time">
                    <el-button type="select" @click="onTimeClick(t, $event)" :id="t.time">{{t.time}}</el-button>
                  </div>
                </div>
              </el-tab-pane>

              <el-tab-pane label="Afternoon" name="Afternoon">
                <div v-if="!afternoonTimes">
                  No Available Times
                </div>
                <div v-else>
                  <div v-for="t in afternoonTimes()" :key="t.time">
                    <el-button type="select" @click="onTimeClick(t, $event)" :id="t.time">{{t.time}}</el-button>
                  </div>
                </div>
              </el-tab-pane>
              
              <el-tab-pane label="Evening" name="Evening">
                <div v-if="!eveningTimes">
                  No Available Times
                </div>
                <div v-else>
                  <div v-for="t in eveningTimes()" :key="t.time">
                    <el-button type="select" @click="onTimeClick(t, $event)" :id="t.time">{{t.time}}</el-button>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>

          </div>
        </el-col>

      </div>

    </div>
  </div>
</template>

<script>
import requests from '../../requests'
import bookingSelect from './BookingSelect'
import VueFlatpickr from 'vue-flatpickr'
import 'vue-flatpickr/theme/airbnb.css'
import { range } from "lodash";

export default {
  name: 'selectionform',
  props: ['bookingData'],
  data(){
    return {
      fpOptions: {
        'inline': true,
        'disable': [
          function(date) {
            return false;
          }
        ],
        'locale': {
          'firstDayOfWeek': 7
        },
        minDate: 'today',
      },
      types: [],
      sites: [],
      scenes: [],
      // This just makes an array of {'time': 'HH:MM'} objects
      // from 09:00 to 21:00 at 30min increments, change step % for smaller incs
      // range's 2nd val is exclusive, so > 21
      allTimes: range(9, 21.1, 0.5).map((v) => { 
        return {'time': new Date(v*60000).toUTCString().split(" ")[4].slice(3) };
      }),
      // Similar to above, but formats to "X hour(s) Y minute(s) Z second(s)"
      durations: range(0.25, 3.1, 0.25).map((v, i) => { 
        var t = new Date(v*3600000).toUTCString().split(" ")[4].split(':');
        var f = '';
        f += t[0] > '00' ? ((t[0] > '10' ? t[0] : t[0][1]) +' hour' + (t[0] > '01' ? 's ' : ' ')) : '';
        f += t[1] > '00' ? ((t[1] > '10' ? t[1] : t[1][1]) +' minute' + (t[1] > '01' ? 's ' : ' ')) : '';
        f += t[2] > '00' ? ((t[2] > '10' ? t[2] : t[2][1]) +' second' + (t[2] > '01' ? 's ' : ' ')) : '';
        return {'id': i, 'time': t.join(':'), 'name': f};
      }),
      availableTimes: [],
      showDateLoading: false,
      activeTab: 'Morning',
      bookings: [],
      avTimesLoaded: false,
    }
  },
  beforeMount(){
    var context = this;
    requests.getFieldTypes(context, function (result) {
      console.log(result)
      if(result.action === 'success') {
        context.types = result.data;
      } else {
        context.$message({
          type: 'error',
          message: 'Couldn\'t get field types: ' + result.msg
        })
      }
    });
    this.getAvailableTimes();

    if(this.bookingData.type) {
      this.getSitesOfType(this.bookingData.type.id);
    }
    if(this.bookingData.site) {
      this.getAllScenesAtSite(this.bookingData.site.id);
    }
  },
  mounted(){
    $(document).off('click').on('click', this.onDocumentClick);
  },
  beforeDestroy(){
    $(document).off('click', this.onDocumentClick);
  },
  methods: {
    onTypeSelected(option) {
      this.$emit('type', option);
    },
    onSiteSelected(option) {
      this.$emit('site', option);
    },
    onDurationSelected(option) {
      this.$emit('duration', option);
    },
    onSceneSelected(option) {
      this.$emit('scene', option);
    },
    onTimeClick(time, event) {
      $('.el-button--select').removeClass('time-selected');
      event.target.classList.add('time-selected');
      this.$emit('time', time);
    },
    onDocumentClick(){
      for (var i = 0; i < $('.booking-select').length; i++) {
        var element = $('.booking-select')[i];
        element.__vue__.showOptions = false;
      }
    },
    getSelectedTime() {
      var time = this.bookingData.time;
      if(time) {
        var mTime = this.morningTimes().filter(t=>(t.time === time));
        var aTime = this.afternoonTimes().filter(t=>(t.time === time));
        var eTime = this.eveningTimes().filter(t=>(t.time === time));

        if( mTime[0] && mTime[0].time === time ){
          this.activeTab = "Morning";
        } else if( aTime[0] && aTime[0].time === time ){
          this.activeTab = "Afternoon";
        } else if( eTime[0] && eTime[0].time === time ){
          this.activeTab = "Evening";
        } 
        this.$nextTick(() => {
          $('.el-button--select').removeClass('time-selected');
          document.getElementById(time).classList.add('time-selected');
        });
      }
    },
    morningTimes() {
      var avTimes = this.availableTimes.filter(function(avTime) {
        if(avTime.time < '12:00') {
          return avTime;
        }
      });
      if(avTimes.length > 0) {
        return avTimes;
      } else {
        return [];
      }
    },
    afternoonTimes() {
      var avTimes = this.availableTimes.filter(function(avTime) {
        if(avTime.time >= '12:00' && avTime.time < '17:00') {
          return avTime;
        }
      });
      if(avTimes.length > 0) {
        return avTimes;
      } else {
        return [];
      }
    },
    eveningTimes() {
      var avTimes = this.availableTimes.filter(function(avTime) {
        if(avTime.time >= '17:00') {
          return avTime;
        }
      });
      if(avTimes.length > 0) {
        return avTimes;
      } else {
        return [];
      }
    },
    timeToSeconds(time) {
      var t = time.split(':');
      return (+t[0])*60*60+(+t[1])*60+(+t[2]);
    },
    getAvailableTimes(){
      var context = this;
      var siteId = context.bookingData.site.id;
      var date = context.bookingData.date;
      this.avTimesLoaded = false;
      if(siteId) {
        requests.getBookingsOnDateAtSite(context, siteId, date, function (result) {
          if(result.action === 'success') {
            var bookings = result.data;
            context.bookings = bookings;
            if(bookings) {
              context.availableTimes = context.allTimes.filter((v)=>{ 
                for(var i = 0; i < bookings.length; i++){
                  var st = context.timeToSeconds(new Date(bookings[i].start_time).toLocaleTimeString());
                  var et = context.timeToSeconds(new Date(bookings[i].end_time).toLocaleTimeString())-1;
                  var cd = new Date().toLocaleDateString('en-AU').split('/').reverse().join('-');
                  var ct = context.timeToSeconds(new Date().toLocaleTimeString());
                  var t = context.timeToSeconds(v.time + ':00')-1;
                  var d = context.timeToSeconds(context.bookingData.duration.time || '00:15:00'); 
                  if(date === cd && t < ct) {
                    return false;
                  }
                  if(t === context.timeToSeconds(context.bookingData.time + ":00")-1) {
                    return true;
                  }
                  if(t >= st && t < et) {
                    return false;
                  }
                  if(t <= st && t+d > st) {
                    return false;
                  }
                }
                return true;
              });
            } else {
              context.availableTimes = context.allTimes.filter((v) => {
                var date = context.bookingData.date;
                var cd = new Date().toLocaleDateString('en-AU').split('/').reverse().join('-');
                var ct = context.timeToSeconds(new Date().toLocaleTimeString());
                var t = context.timeToSeconds(v.time + ':00');
                if(date === cd && t < ct) {
                  return false;
                }
                return true;
              });
            }
            context.avTimesLoaded = true;
          }
        });
      }
    },
    getSitesOfType(id){
      var context = this;
      requests.getSitesOfType(context, id, function(result){
        if(result.action === 'success') {
          var sites = result.data;
          if(sites && sites.length > 0) {
            context.sites = sites;
          } else {
            context.sites = [];
            context.scenes = [];
            context.$emit('site', '');
            context.$emit('scene', '');
          }
        } else {
          context.$message({
            type: 'error',
            message: 'Could not get sites: ' + result.msg
          })
        }
      });
    },
    getAllScenesAtSite(id){
      var context = this;
      requests.getAllScenesAtSite(context, id, function(result){
        if(result.action === 'success') {
          var scenes = result.data;
          if(scenes && scenes.length > 0) {
            context.scenes = scenes;
          } else {
            context.scenes = [];
            context.$emit('scene', {});
          }
        } else {
          context.$message({
            type: 'error',
            message: 'Could not get scenes: ' + result.msg
          })
        }
      });  
    },
  },
  watch: {
    'bookingData.date': function(){
      this.$emit('date', this.bookingData.date);
      this.showDateLoading = true;
      setTimeout(() => {
        this.getAvailableTimes();      
        this.showDateLoading = false;
      }, 500);
    },

    'bookingData.type': function(newVal) {
      if(newVal) {
        this.getSitesOfType(newVal.id);
      } else {
        this.sites = [];
        this.bookingData.date = '';
        this.bookingData.time = '';
        $('.el-button--select').removeClass('time-selected');
        $('.flatpickr-day').removeClass('selected');
      }
    },

    'bookingData.site': function(newVal, oldVal) {
      if(!oldVal) {
        this.bookingData.date = new Date().toLocaleDateString('en-AU').split('/').reverse().join('-')
        $('.flatpickr-day.today').addClass('selected');
      }

      if(newVal) {
        this.getAllScenesAtSite(newVal.id);    
      } else {
        this.scenes = [];
        this.bookingData.date = '';
        this.bookingData.time = '';
        $('.el-button--select').removeClass('time-selected');
        $('.flatpickr-day').removeClass('selected');
      }
    },
    'bookingData.duration': function() {
      this.getAvailableTimes();
    },
    'availableTimes': function(newVal, oldVal){
      if(oldVal.length === 0) {
        this.getSelectedTime();
      }
    },
    'avTimesLoaded': function(newVal) {
      
      if(newVal) {
        var context = this;
        var at = this.availableTimes.filter(t=>(t.time === context.bookingData.time));
        if( !at[0] || at[0].time !== this.bookingData.time ) {
          this.bookingData.time = '';
          $('.el-button--select').removeClass('time-selected');         
        }
      }
    }
  },
  computed: { 
    prettyDateTag: function() {
      var today = new Date().toLocaleDateString('en-AU');
      var selectedDate = new Date(this.bookingData.date);
      if(this.bookingData.date && selectedDate.toLocaleDateString('en-AU') != today)
        return selectedDate.toDateString();
      else 
       return "Today"
    },
    showSites: function(){
      return this.sites.length > 0 || this.bookingData.type;
    },
    showScenes: function(){
      return this.scenes.length > 0 || this.bookingData.site;    
    },
  },
  components: {
    'bookingselect': bookingSelect,
    'flatpickr': VueFlatpickr
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// SelectionForm.vue?8c75db50